/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import styled from 'styled-components';
import { Flex } from 'reflexbox';

const SWITCH_BACKGROUND_DEFAULT_COLOR_ON = '#81C784';
const SWITCH_BACKGROUND_DEFAULT_COLOR_OFF = '#FFCC66';

const SwitchBackground = styled(Flex)`
  width: 150px;
  cursor: pointer;
  height: 28px;
  background-color: ${(props) => (props.checked ? 
          (props.colorOn ?? SWITCH_BACKGROUND_DEFAULT_COLOR_ON) :
          (props.colorOff ?? SWITCH_BACKGROUND_DEFAULT_COLOR_OFF) 
  )};
  font-family: Roboto Mono;
  letter-spacing: 0;
  color: #1d1d1d;
`;
SwitchBackground.displayName = 'SwitchButton-SwitchBackground';

const SwitchIcon = styled.div`
  width: 30px;
  height: 30px;
  top: -29px;
  cursor: pointer;
  left: ${(props) => (!props.checked ? '0px' : '120px')};
  position: relative;
  z-index: 1;
  transition: all 300ms ease;
`;
SwitchIcon.displayName = 'SwitchButton-SwitchIcon';

const SwitchButtonContainer = styled.div`
    height: 30px;
`;
SwitchButtonContainer.displayName = 'SwitchButton-SwitchButtonContainer';

function SwitchButton(props) {
  const { checked, handleToggle, id, onIcon, offIcon, onText, offText, invertColors = false, disabled = false } = props;
  const changeInput = () => {
    if (disabled) return;
    handleToggle({
      target: {
        value: !checked,
        id,
      },
    });
  };
  return (
    <SwitchButtonContainer onClick={changeInput} aria-hidden>
      <SwitchBackground checked={checked} alignItems="center" justifyContent="center"
                        colorOn={!invertColors ? SWITCH_BACKGROUND_DEFAULT_COLOR_ON : SWITCH_BACKGROUND_DEFAULT_COLOR_OFF}
                        colorOff={!invertColors ? SWITCH_BACKGROUND_DEFAULT_COLOR_OFF : SWITCH_BACKGROUND_DEFAULT_COLOR_ON}>
        {checked ? onText : offText}
      </SwitchBackground>
      <SwitchIcon checked={checked}>{checked ? onIcon : offIcon}</SwitchIcon>
    </SwitchButtonContainer>
  );
}
export default SwitchButton;
